import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppConfig } from '../context/AppConfigContext';

const MobileNav = ({ navItems, onLogout, userName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { appConfig } = useAppConfig();
  const companyName = appConfig?.company_name || null;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Menu Burger Button */}
      <button 
        className="mobile-menu-button md:hidden"
        onClick={toggleMenu}
        aria-label="Menu"
      >
        ☰
      </button>

      {/* Overlay */}
      <div 
        className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`}
        onClick={closeMenu}
      />

      {/* Sidebar */}
      <div className={`mobile-nav-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="mobile-nav-header">
          <button 
            className="mobile-nav-close"
            onClick={closeMenu}
          >
            ✕
          </button>
          <h2 className="text-xl font-bold mb-1">{companyName || ''}</h2>
          {userName && (
            <p className="text-sm opacity-90">{userName}</p>
          )}
        </div>

        <nav className="mobile-nav-items">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <span className="mobile-nav-item-icon">{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        {onLogout && (
          <div className="p-4 border-t border-gray-200">
            <button
              onClick={() => {
                closeMenu();
                onLogout();
              }}
              className="w-full py-3 px-4 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors"
            >
              🚪 Déconnexion
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileNav;
